var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.metaData
    ? _c("div", { staticClass: "working-hours" }, [
        !_vm.readonly || _vm.showWorkingHours
          ? _c("div", [
              !_vm.hideLabel
                ? _c(
                    "label",
                    {
                      class: {
                        "required-flag": _vm.isMandatory && !_vm.readonly,
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t("tender.general." + _vm.metaData.fieldName)
                          ) +
                          ":"
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.metaData.value
                ? _c(
                    "ul",
                    {
                      staticClass: "working-hours-list",
                      class:
                        ((_obj = {}),
                        (_obj[_vm.metaData.addendumClassName] =
                          _vm.metaData.isRevised),
                        _obj),
                    },
                    _vm._l(_vm.metaData.value, function (workingHour, index) {
                      return workingHour
                        ? _c("li", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "small-4 medium-4 large-4" },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(workingHour.workingDayFrom) +
                                    " " +
                                    _vm._s(
                                      workingHour.workingDayTo &&
                                        workingHour.workingDayTo !== "--/--" &&
                                        workingHour.workingDayTo !==
                                          workingHour.workingDayFrom
                                        ? "- " + workingHour.workingDayTo
                                        : ""
                                    ) +
                                    "\n        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "small-7 medium-7 large-7" },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(workingHour.workingHourFrom) +
                                    " " +
                                    _vm._s(
                                      workingHour.workingHourTo &&
                                        workingHour.workingHourTo !== "--/--" &&
                                        workingHour.workingHourTo !==
                                          workingHour.workingHourFrom
                                        ? "- " + workingHour.workingHourTo
                                        : ""
                                    ) +
                                    "\n        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            !_vm.readonly
                              ? _c("a", {
                                  staticClass: "fa fa-times fa-lg",
                                  class: "delete-working-hour-" + index,
                                  attrs: { "aria-hidden": true },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteWorkingHour(index)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ])
                        : _vm._e()
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.readonly && _vm.showWorkingHours ? _c("hr") : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.readonly
          ? _c(
              "div",
              { staticClass: "working-hours-add" },
              [
                _c("HKLSelect", {
                  staticClass: "workingDayFrom",
                  class: {
                    "error-highlight":
                      _vm.invalidWorkingHour ||
                      (_vm.isMandatory && _vm.emptyWorkingHours),
                  },
                  attrs: {
                    name: "workingDayFrom",
                    value: _vm.workingDayFrom || undefined,
                    options: _vm.workingDayFromHklOptions,
                    showSearch: true,
                    placeholder: "",
                  },
                  on: {
                    change: function ($event) {
                      _vm.workingDayFrom = $event || ""
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "dash" }),
                _vm._v(" "),
                _c("HKLSelect", {
                  staticClass: "workingDayTo",
                  class: {
                    "error-highlight":
                      _vm.invalidWorkingHour ||
                      (_vm.isMandatory && _vm.emptyWorkingHours),
                  },
                  attrs: {
                    name: "workingDayTo",
                    disabled: _vm.workingDayFrom === "PH",
                    value: _vm.workingDayTo || undefined,
                    options: _vm.workingDayToHklOptions,
                    showSearch: true,
                    placeholder: "",
                  },
                  on: {
                    change: function ($event) {
                      _vm.workingDayTo = $event || ""
                    },
                  },
                }),
                _vm._v(" "),
                _c("HKLSelect", {
                  staticClass: "workingHourFrom",
                  class: {
                    "error-highlight":
                      _vm.invalidWorkingHour ||
                      (_vm.isMandatory && _vm.emptyWorkingHours),
                  },
                  attrs: {
                    name: "workingHourFrom",
                    value: _vm.workingHourFrom || undefined,
                    options: _vm.workingHourFromHklOptions,
                    showSearch: true,
                    placeholder: "",
                  },
                  on: {
                    change: function ($event) {
                      _vm.workingHourFrom = $event || ""
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "dash" }),
                _vm._v(" "),
                _c("HKLSelect", {
                  staticClass: "workingHourTo",
                  class: {
                    "error-highlight":
                      _vm.invalidWorkingHour ||
                      (_vm.isMandatory && _vm.emptyWorkingHours),
                  },
                  attrs: {
                    name: "workingHourTo",
                    disabled: _vm.workingHourFrom === "Anytime",
                    value: _vm.workingHourTo || undefined,
                    options: _vm.workingHourToHklOptions,
                    showSearch: true,
                    placeholder: "",
                  },
                  on: {
                    change: function ($event) {
                      _vm.workingHourTo = $event || ""
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--darkblue btn-add add-working-hour",
                    attrs: {
                      disabled: _vm.disableButton(),
                      type: "button",
                      id: "modules-tenders-workingHours-add",
                      name: "add-working-hour",
                    },
                    on: { click: _vm.addWorkingHour },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.add")))]
                ),
              ],
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }